import { useSelector } from "react-redux";

export const useCompanyDateFormat = () => {
    const selectedDateFormat = useSelector(
        (state) => state?.common?.selectedDateFormat || "1"
    );

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);

        switch (selectedDateFormat) {
            case "1":
                return date.toLocaleDateString("en-GB");
            case "2":
                return date.toLocaleDateString("en-US");
            case "3":
                return date.toISOString().slice(0, 10);
            case "4":
                return date.toLocaleDateString("en-GB", {
                    day: "2-digit", month: "long", year: "numeric",
                });
            case "5":
                return date.toLocaleDateString("en-GB", {
                    weekday: "long", day: "2-digit", month: "short", year: "numeric",
                });
            case "6":
                return date.toLocaleDateString("en-GB", {
                    day: "2-digit", month: "short", year: "2-digit",
                });

            default:
                return date.toLocaleDateString();
        }
    };

    return formatDate;
};
